import { SxProps, Theme } from '@mui/material';

export const CINEMA_PRIMARY = '#ffc63e';
export const CINEMA_SURFACE = '#131313';
export const CINEMA_ON_SURFACE = '#e5e2e1';
export const CINEMA_OUTLINE = 'rgba(77, 70, 53, 0.2)';

/**
 * Cinema glass fragments — asserted loosely so `{ ...glassCardSx, ...responsive }` stays valid under
 * strict MUI `sx` inference (SystemStyleObject + responsive objects do not intersect cleanly).
 */
export const glassCardSx = {
    background: 'rgba(42, 42, 42, 0.4)',
    backdropFilter: 'blur(24px)',
    WebkitBackdropFilter: 'blur(24px)',
    borderTop: `1px solid ${CINEMA_OUTLINE}`,
    borderLeft: `1px solid ${CINEMA_OUTLINE}`,
} as any;

export const ghostBorderSx = {
    border: '1px solid rgba(153, 144, 124, 0.2)',
} as any;

/** Vertical rhythm between watch sections (scroll rows keep their own spacing). */
export const watchSectionSpacing = { mb: { xs: 3.5, sm: 4, md: 7 } };

/** Spotlight hero — shorter on phones so it does not dominate the viewport. */
export const watchHeroHeight = { xs: 200, sm: 280, md: 360, lg: 400 };

/** Grid / bento video thumbs — fixed height on small screens, aspect ratio from tablet up. */
export const watchThumbMediaSx = {
    position: 'relative',
    width: '100%',
    overflow: 'hidden',
    height: { xs: 104, sm: 132, md: 'auto' },
    aspectRatio: { md: '16 / 9' },
    maxHeight: { md: 220 },
} as const;

/** Glass surface for dashboard stat cards, charts, and panels (matches projects / jury obsidian style). */
export const dashboardGlassSx = {
    ...glassCardSx,
    ...ghostBorderSx,
    borderRadius: 3,
    transition: 'background-color 0.25s ease',
    '&:hover': {
        backgroundColor: 'rgba(42, 42, 42, 0.52)',
    },
} as SxProps<Theme>;
